module.exports = __webpack_public_path__ + "static/media/LHSlidingIn.275ec5fc.svg";